(function (learning, $) {
    /* Initialize dropdown validation that prevents duplicates*/
    learning.InitDropDownValidation = function () {
        var dropdownPlaceholder = "Selecteer een update connector";

        var controlsToValidate = $('[data-validatecontrol]');
        var originalValues = [];
        $.each(controlsToValidate, function (index, controlToValidate) {
            var selectedValue = $(controlToValidate).val();
            originalValues.push(selectedValue);

            if (selectedValue !== '') {
                // Removes all selected values from the 'other' controls
                $.each(controlsToValidate, function (subIndex, subControl) {
                    if (controlToValidate !== subControl) {
                        $(subControl).find("option[value='" + selectedValue + "']").remove();
                    }
                });
            }

            var currentlySelectedValue;
            $(controlToValidate).on('focus', function () {
                currentlySelectedValue = this.value;
            }).change(function () {
                var focussedControl = this;

                $.each(controlsToValidate, function (subIndex, subControl) {
                    var selectedValue = $(subControl).find("option:selected").text();

                    if (focussedControl != subControl) {
                        $(subControl).append($('<option></option>').val(currentlySelectedValue).html(currentlySelectedValue));
                        if (focussedControl.value != '') {
                            $(subControl).find("option[value='" + focussedControl.value + "']").remove();
                        }

                        // Sort collection
                        var sorted = [];
                        $(subControl).find("option").each(function () {
                            if (this.value != '') {
                                sorted.push(this.value);
                            }
                        });
                        sorted.sort();

                        $(subControl).find('option').not(':eq(0)').remove();

                        // Append sorted collection
                        var htmlAppend = '';
                        $.each(sorted, function (index, value) {
                            if (value != dropdownPlaceholder && value != '' && value != null) {
                                htmlAppend += '<option value="' + value + '">' + value + '</option>';
                            }
                        });
                        $(subControl).append(htmlAppend);
                        if (selectedValue != dropdownPlaceholder) {
                            $(subControl).val(selectedValue);
                        }
                    }
                    // disable edit buttons and show message
                    else {
                        var index = controlsToValidate.index(focussedControl);
                        var originalValueOfControl = originalValues[index];

                        var editButtons = $('[data-' + originalValueOfControl.toLowerCase() + '] > table td > a[data-editbutton]');
                        var alert = $('[data-' + originalValueOfControl.toLowerCase() + ']').parent('div').find('[data-warning]');
                        if (selectedValue === originalValueOfControl) {
                            editButtons.removeClass('disabled');
                            alert.hide();
                        }
                        else {
                            editButtons.addClass('disabled');
                            alert.show();
                        }
                    }
                });

                currentlySelectedValue = this.value;
            });
        });
    }
}(window.learning = window.learning || {}, jQuery));
